import { useEffect } from "react";
import { useHotglue } from "@hotglue/widget";
import { useAuth0 } from "@auth0/auth0-react";
import { recordConnectionEvent } from "@/modules/hub/features/HotglueDataConnector/api/recordConnectionEvent";

export const useQuickBooksConnection = (intacctId?: string) => {
  const { setMetadata, setListener } = useHotglue();
  const { user } = useAuth0();

  useEffect(() => {
    if (intacctId && user) {
      setMetadata({
        application: "Hub Plus",
        ssoId: user.sub,
      });
    }
  }, [intacctId, user, setMetadata]);

  useEffect(() => {
    setListener({
      // Fire-and-forget adoption tracking; the catch keeps a failure from
      // reaching the widget or surfacing as an unhandled rejection.
      onSourceLinked: (source) =>
        recordConnectionEvent({ tap: source?.tap ?? "quickbooks" }).catch(
          () => {},
        ),
    });
  }, [setListener]);
};
